import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { FieldArray, getIn } from 'formik';

import FilesFieldListHeader from 'components/FilesFieldList/components/FilesFieldListHeader';
import FilesFieldListItem from './components/FilesFieldListItem';

import './styles.css';

const FilesFieldList = props => {
  const {
    header,
    title,
    name,
    files,
    disabled,
    onAdd,
    onRemove,
    onDownloadAttach,
  } = props;

  const refInputFile = useRef();

  const addFile = (e, push) => {
    if (e.target.files && e.target.files.length) {
      const files = [...e.target.files].map(f => {
        const obj = { file: f, description: '' };
        push(obj);
        return obj;
      });

      e.target.value = '';

      onAdd(files);
    }
  };

  const handleRemove = (index, id, remove) => {
    onRemove && typeof onRemove === 'function' && onRemove(index, id, remove);
  };

  const renderHeader = inputRef =>
    header ? (
      header({ inputRef, title, disabled })
    ) : (
      <FilesFieldListHeader
        inputRef={inputRef}
        title={title}
        disabled={disabled}
      />
    );

  return (
    <FieldArray
      name={name}
      validateOnChange
      render={({ remove, push, form }) => (
        <>
          {renderHeader(refInputFile)}

          <input
            ref={refInputFile}
            multiple
            hidden
            type="file"
            onChange={e => addFile(e, push)}
          />

          <div className="files-field-list">
            {files &&
              files.length > 0 &&
              files.map((f, i) => {
                const errors = getIn(form.errors, name);
                const error = errors && errors[i] ? errors[i] : false;

                return (
                  <Fragment key={i}>
                    <FilesFieldListItem
                      isValid={!error}
                      index={i}
                      value={f}
                      isUploaded={f.isUploaded}
                      onRemove={(index, isUploaded) =>
                        handleRemove(index, isUploaded, remove)
                      }
                      onDownload={onDownloadAttach}
                    />
                    {error && (
                      <div className="files-field-list__error">{error}</div>
                    )}
                  </Fragment>
                );
              })}
          </div>
        </>
      )}
    />
  );
};

FilesFieldList.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  files: PropTypes.array,
  disabled: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onDownloadAttach: PropTypes.func,
};

export default FilesFieldList;
